export const translations = {
  es: {
    titleCaixa: 'Control de salud y cognitivo',
    titleQida: 'Plan de prevención y reducción de riesgos personalizado',
    scheduled: 'Programado:',
    date: 'Viernes, <strong>10 de enero de 2025</strong> a las <strong>15:00h</strong>.',
    joinButton: 'UNIRSE',
  },

  ca: {
    titleCaixa: 'Control de salut i cognitiu',
    titleQida: 'Plan de prevenció i reducció de riscos personalitzat',
    scheduled: 'Programat:',
    date: 'Divendres, <strong>10 de gener de 2025</strong> a les <strong>15:00h</strong>.',
    joinButton: 'UNIR-SE',
  },
}
